var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXLarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 2182.322,
    height: 2258.508,
    viewBox: "0 0 2182.322 2258.508",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 0.45,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.805,
    stopColor: "#00254f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922,
    stopColor: "#0f315e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c3b6a"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "X-large",
    d: "M.959,603.811V35.48c0-30.906,45.5-46.359,72.973-25.755l988.14,762.353c16.312,12.878,42.925,12.878,59.237,0L2109.449,9.725c27.472-21.463,72.973-5.151,72.973,25.755V603.811c0,9.444-5.151,18.887-13.736,25.755L1554,1103.462c-18.029,13.736-18.029,36.916,0,50.652l613.832,474.754c8.585,6.868,13.736,15.453,13.736,25.755v567.472c0,30.906-45.5,46.359-72.973,25.755l-988.14-764.929c-16.312-12.878-42.925-12.878-59.237,0L73.073,2248.708C45.6,2270.171.1,2253.86.1,2222.953V1655.481c0-9.444,5.151-18.887,13.736-25.755l613.832-474.754c18.029-13.736,18.029-36.916,0-50.652L13.836,629.566C5.251,622.7.959,613.255.959,603.811Z",
    transform: "translate(-0.1 0.037)",
    opacity: 0.04,
    fill: "url(#radial-gradient)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXLarge);
export default __webpack_public_path__ + "static/media/x_large.96ba8998bd15ab832291e2200c3e7411.svg";
export { ForwardRef as ReactComponent };